import { Tabs, Tab } from 'material-ui/Tabs';
import { ToolbarGroup } from 'material-ui/Toolbar';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { Link } from 'react-router-dom';

import { accent1Color, appBarColor, primary1Color } from 'constants/colors';
import { adminMenu, loggedOutMenu, sellerMenu } from 'constants/menuItems';
import HiddenOnSize from 'components/shared/HiddenOnSize';

const style = {
    inkBar: {
        backgroundColor: primary1Color,
        borderRadius: 2,
        height: 4,
        marginLeft: 15,
        marginRight: 15,
        width: 100,
    },
    tab: {
        color: accent1Color,
        fontSize: 15,
        fontWeight: 400,
        marginLeft: 15,
        marginRight: 15,
        textTransform: 'capitalize',
        width: 100,
    },
    tabItemContainer: {
        backgroundColor: appBarColor,
    },
};

const TabBar = ({ isLoggedIn, me, pathname }) => {
    const activeTabValue = `/${pathname.split('/')[1] || ''}`;
    const isAdmin = me.get('isAdmin');

    return (
        r(ToolbarGroup, [
            r(HiddenOnSize, { sizes: ['sm', 'xs'] }, [
                r.div({ isRendered: isLoggedIn }, [
                    r(Tabs, {
                        inkBarStyle: style.inkBar,
                        isRendered: !isAdmin,
                        tabItemContainerStyle: style.tabItemContainer,
                        value: activeTabValue,
                    }, [
                        sellerMenu.map(({ activeAt, isRenderedPath = [], label, url }) => (
                            r(Tab, {
                                buttonStyle: { height: 60 },
                                containerElement: r(Link, { to: url }),
                                disableTouchRipple: true,
                                isRendered: me.getIn(isRenderedPath, true),
                                key: label,
                                label,
                                style: style.tab,
                                value: activeAt,
                            })
                        ))
                    ]),
                    r(Tabs, {
                        inkBarStyle: style.inkBar,
                        isRendered: isAdmin,
                        tabItemContainerStyle: style.tabItemContainer,
                        value: activeTabValue,
                    }, [
                        adminMenu.map(({ activeAt, label, url }) => (
                            r(Tab, {
                                buttonStyle: { height: 60 },
                                containerElement: r(Link, { to: url }),
                                disableTouchRipple: true,
                                key: label,
                                label,
                                style: style.tab,
                                value: activeAt,
                            })
                        ))
                    ]),
                ]),
                r(Tabs, {
                    inkBarStyle: style.inkBar,
                    isRendered: !isLoggedIn,
                    tabItemContainerStyle: style.tabItemContainer,
                    value: activeTabValue,
                }, [
                    loggedOutMenu.map(({ activeAt, label, url }) => (
                        r(Tab, {
                            buttonStyle: { height: 60 },
                            disableTouchRipple: true,
                            href: url,
                            key: label,
                            label,
                            style: style.tab,
                            value: activeAt,
                        })
                    ))
                ]),
            ]),
        ])
    );
};

TabBar.propTypes = { pathname: PropTypes.string.isRequired };

export default TabBar;



// WEBPACK FOOTER //
// ./src/components/public/Navigation/NavigationBar/TabBar/index.js